import { FC, useState } from 'react'
import clsx from 'clsx'

import Button from '../../button/button'
import Loader from '../../loader/loader'

import styles from './comment-input-block.module.scss'
import ButtonThemes from 'components/parts/button/themes'

interface ICommentInputBlock {
  inputText: string
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  handleSend: () => void
  closeAnswerBlock?: () => void
  isBthBlocked?: boolean
}

const CommentInputBlock: FC<ICommentInputBlock> = ({
  inputText,
  handleChange,
  handleSend,
  closeAnswerBlock,
  isBthBlocked = false,
}: ICommentInputBlock) => {
  const [isTextareaInFocus, setTextareaIsInFocus] = useState(false)

  const isBtnDisabled = isBthBlocked || !inputText

  const handleTextareaFocus = () => setTextareaIsInFocus((prevState) => !prevState)

  return (
    <div className={clsx(styles.commentInputBlock, { [styles.whiteBG]: isTextareaInFocus })}>
      <textarea
        rows={1}
        cols={45}
        className={styles.textarea}
        value={inputText}
        placeholder="Написать комментарий..."
        onChange={handleChange}
        onFocus={handleTextareaFocus}
        onBlur={handleTextareaFocus}
      />
      <div className={styles.containerButton}>
        {Boolean(closeAnswerBlock) && (
          <div className={styles.button} onClick={closeAnswerBlock}>
            <p className={styles.buttonLogin}>Отменить</p>
          </div>
        )}
        <div className={styles.sendLine}>
          {isBthBlocked && <Loader />}
          <div className={styles.buttonSend}>
            <Button
              modificator={styles.smallerPadding}
              onClick={handleSend}
              disabled={isBtnDisabled}
              theme={isBtnDisabled ? ButtonThemes.SECOND : undefined}
            >
              Отправить
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommentInputBlock
